// extracted by mini-css-extract-plugin
export var footnoteLink = "footnote-link-module--footnoteLink--e9d3b";
export var footnoteLinkParenthesis = "footnote-link-module--footnoteLinkParenthesis--996c3";
export var footnotePlaceholder = "footnote-link-module--footnotePlaceholder--98b36";
export var footnoteSuper = "footnote-link-module--footnoteSuper--e737a";